module.exports = __webpack_public_path__ + "fonts/34D30C_0_0.0840e37e.woff2";